import { ca } from '@cian/analytics';

import { EBlockInPageName } from '../types/share';

export function trackBlockInPageViewed(blockInPage: EBlockInPageName) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AnalisysOnline',
    action: 'Scroll',
    label: blockInPage,
  });
}
